import styles from "./PixelNumber.module.css";

const Zero = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path
        stroke="#000000"
        d="M0 0h5M0 1h1M4 1h1M0 2h1M2 2h1M4 2h1M0 3h1M2 3h1M4 3h1M0 4h1M2 4h1M4 4h1M0 5h1M4 5h1M0 6h5"
      />
      <path stroke="#fff4cc" d="M1 1h3" />
      <path stroke="#fbf005" d="M1 2h1M3 2h1M1 3h1M3 3h1M1 4h1M3 4h1" />
      <path stroke="#f8c200" d="M1 5h3" />
    </svg>
  );
};

const One = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path
        stroke="#000000"
        d="M1 0h3M0 1h2M3 1h1M0 2h1M3 2h1M1 3h1M3 3h1M0 4h2M3 4h2M0 5h1M4 5h1M0 6h5"
      />
      <path stroke="#fff4cc" d="M2 1h1" />
      <path stroke="#fbf005" d="M1 2h2M2 3h1M2 4h1" />
      <path stroke="#f8c200" d="M1 5h3" />
    </svg>
  );
};

const Two = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path
        stroke="#000000"
        d="M0 0h5M0 1h1M4 1h1M0 2h3M4 2h1M0 3h1M4 3h1M0 4h1M2 4h3M0 5h1M4 5h1M0 6h5"
      />
      <path stroke="#fff4cc" d="M1 1h3" />
      <path stroke="#fbf005" d="M3 2h1M1 3h3M1 4h1" />
      <path stroke="#f8c200" d="M1 5h3" />
    </svg>
  );
};

const Three = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path
        stroke="#000000"
        d="M0 0h5M0 1h1M4 1h1M0 2h3M4 2h1M0 3h1M4 3h1M0 4h3M4 4h1M0 5h1M4 5h1M0 6h5"
      />
      <path stroke="#fff4cc" d="M1 1h3" />
      <path stroke="#fbf005" d="M3 2h1M1 3h3M3 4h1" />
      <path stroke="#f8c200" d="M1 5h3" />
    </svg>
  );
};

const Four = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path
        stroke="#000000"
        d="M0 0h5M0 1h1M2 1h1M4 1h1M0 2h1M2 2h1M4 2h1M0 3h1M4 3h1M0 4h3M4 4h1M2 5h1M4 5h1M2 6h3"
      />
      <path stroke="#fff4cc" d="M1 1h1M3 1h1" />
      <path stroke="#fbf005" d="M1 2h1M3 2h1M1 3h3M3 4h1" />
      <path stroke="#f8c200" d="M3 5h1" />
    </svg>
  );
};

const Five = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path
        stroke="#000000"
        d="M0 0h5M0 1h1M4 1h1M0 2h1M2 2h3M0 3h1M4 3h1M0 4h3M4 4h1M0 5h1M4 5h1M0 6h5"
      />
      <path stroke="#fff4cc" d="M1 1h3" />
      <path stroke="#fbf005" d="M1 2h1M1 3h3M3 4h1" />
      <path stroke="#f8c200" d="M1 5h3" />
    </svg>
  );
};

const Six = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path
        stroke="#000000"
        d="M0 0h5M0 1h1M4 1h1M0 2h1M2 2h3M0 3h1M4 3h1M0 4h1M2 4h1M4 4h1M0 5h1M4 5h1M0 6h5"
      />
      <path stroke="#fff4cc" d="M1 1h3" />
      <path stroke="#fbf005" d="M1 2h1M1 3h3M1 4h1M3 4h1" />
      <path stroke="#f8c200" d="M1 5h3" />
    </svg>
  );
};

const Seven = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path
        stroke="#000000"
        d="M0 0h5M0 1h1M4 1h1M0 2h3M4 2h1M2 3h1M4 3h1M2 4h1M4 4h1M2 5h1M4 5h1M2 6h3"
      />
      <path stroke="#fff4cc" d="M1 1h3" />
      <path stroke="#fbf005" d="M3 2h1M3 3h1M3 4h1" />
      <path stroke="#f8c200" d="M3 5h1" />
    </svg>
  );
};

const Eight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path
        stroke="#000000"
        d="M0 0h5M0 1h1M4 1h1M0 2h1M2 2h1M4 2h1M0 3h1M4 3h1M0 4h1M2 4h1M4 4h1M0 5h1M4 5h1M0 6h5"
      />
      <path stroke="#fff4cc" d="M1 1h3" />
      <path stroke="#fbf005" d="M1 2h1M3 2h1M1 3h3M1 4h1M3 4h1" />
      <path stroke="#f8c200" d="M1 5h3" />
    </svg>
  );
};

const Nine = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path
        stroke="#000000"
        d="M0 0h5M0 1h1M4 1h1M0 2h1M2 2h1M4 2h1M0 3h1M4 3h1M0 4h3M4 4h1M2 5h1M4 5h1M2 6h3"
      />
      <path stroke="#fff4cc" d="M1 1h3" />
      <path stroke="#fbf005" d="M1 2h1M3 2h1M1 3h3M3 4h1" />
      <path stroke="#f8c200" d="M3 5h1" />
    </svg>
  );
};

const Dash = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 5 7"
      shapeRendering="crispEdges"
      className={styles.svgCharacter}
    >
      <path stroke="#000000" d="M0 2h5M0 3h1M4 3h1M0 4h5" />
      <path stroke="#fbf005" d="M1 3h3" />
    </svg>
  );
};

const componentMap = {
  0: <Zero />,
  1: <One />,
  2: <Two />,
  3: <Three />,
  4: <Four />,
  5: <Five />,
  6: <Six />,
  7: <Seven />,
  8: <Eight />,
  9: <Nine />,
  "-": <Dash />,
};

export default function PixelNumber({ number }) {
  const mappedChars = String(number)
    .split("")
    .map((key, i) => {
      return <span key={i}>{componentMap[key]}</span>;
    });

  return <div className={styles.pixelNumber}>{mappedChars}</div>;
}
